














































import { RealworksStatusRule } from '@/api/model/realworks-status-rule'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CreatePhaseStatusVerticalStep2 extends Vue {
    @Prop( { required: true }) readonly currentStep!: number
    @Prop( { default: false }) readonly existing!: boolean
    @Prop( { required: true }) readonly value!: RealworksStatusRule
}
